import React from 'react';
import classnames from 'classnames';

import './warranty-progress.scss';

const INNER_CIRCLE_FULL_LENGTH = 194.68;
const OUTER_CIRCLE_FULL_LENGTH = 320;

const getStyles = (dashLength, fullLength) => ({
  '--dash-length': dashLength,
  '--full-length': fullLength,
});

export const warrantyProgress = (outerCircleFillPercent, innerCircleFillPercent, animate) => {
  const outerCircleDashLength = OUTER_CIRCLE_FULL_LENGTH * outerCircleFillPercent;
  const innerCircleDashLength = INNER_CIRCLE_FULL_LENGTH * innerCircleFillPercent;

  return (
    <svg viewBox="0 0 112 112">
      <title>Warranty remaining</title>
      <path d="M56 4a51 51 0 0 1 0 102A51 51 0 0 1 56 4" fill="none" stroke="#CBD4E1" strokeWidth={6} />
      <path
        d="M56 4a51 51 0 0 0 0 102A51 51 0 0 0 56 4"
        className={classnames({ animate })}
        style={{ ...getStyles(outerCircleDashLength, OUTER_CIRCLE_FULL_LENGTH) }}
        fill="none"
        stroke="#1561D4"
        strokeWidth={8}
        strokeLinecap="round"
        strokeDasharray={`${OUTER_CIRCLE_FULL_LENGTH}, 0`}
      />
      <path d="M56 24a31 31 0 0 1 0 62 31 31 0 0 1 0-62" fill="none" stroke="#CBD4E1" strokeWidth={6} />
      <path
        d="M56 24a31 31 0 0 0 0 62 31 31 0 0 0 0-62"
        className={classnames({ animate })}
        style={{ ...getStyles(innerCircleDashLength, INNER_CIRCLE_FULL_LENGTH) }}
        fill="none"
        stroke="#00A0B5"
        strokeWidth={8}
        strokeLinecap="round"
        strokeDasharray={`${INNER_CIRCLE_FULL_LENGTH}, 0`}
      />
      <path
        d="M60.557 55.79a8.738 8.738 0 0 0 1.836-1.563 9.677 9.677 0 0 0 1.426-2.031c.403-.755.709-1.569.918-2.442a11.007 11.007 0 0 0 .312-3.339l-.039-.625H47.627l-.039.625a11.66 11.66 0 0 0 .293 3.339c.221.873.527 1.687.918 2.442.404.742.879 1.419 1.426 2.031a9.18 9.18 0 0 0 1.855 1.563 9.143 9.143 0 0 0-1.855 1.562 10.486 10.486 0 0 0-1.426 2.051 10.923 10.923 0 0 0-.918 2.422 11.662 11.662 0 0 0-.293 3.34l.039.625H65.01l.039-.625a11.01 11.01 0 0 0-.312-3.34 9.856 9.856 0 0 0-.918-2.422 9.479 9.479 0 0 0-1.426-2.051 8.703 8.703 0 0 0-1.836-1.562zm-11.113 8.75c0-.912.097-1.778.293-2.598a9.185 9.185 0 0 1 .839-2.266 7.06 7.06 0 0 1 1.368-1.757 5.583 5.583 0 0 1 1.875-1.153v-1.953a5.73 5.73 0 0 1-1.875-1.133 7.436 7.436 0 0 1-1.368-1.777 9.23 9.23 0 0 1-.839-2.246 11.403 11.403 0 0 1-.293-2.617h13.75c0 .911-.098 1.783-.293 2.617a8.758 8.758 0 0 1-.86 2.246 6.8 6.8 0 0 1-1.367 1.777 5.51 5.51 0 0 1-1.855 1.133v1.953a5.374 5.374 0 0 1 1.855 1.153 6.48 6.48 0 0 1 1.367 1.757 8.72 8.72 0 0 1 .86 2.266c.195.82.293 1.686.293 2.598h-13.75zm8.984-5.664c-.703-.404-1.126-.834-1.27-1.289-.143-.469-.214-.86-.214-1.172v-1.25c0-.313.071-.697.214-1.153.144-.469.567-.905 1.27-1.308a4.345 4.345 0 0 0 1.035-.801c.326-.339.612-.71.86-1.113h-8.008c.247.416.527.787.84 1.113a4.74 4.74 0 0 0 1.054.801c.703.403 1.127.839 1.27 1.308.143.456.215.84.215 1.153v1.25c0 .312-.072.703-.215 1.172-.143.455-.567.885-1.27 1.289-.703.403-1.308.996-1.816 1.777a6.916 6.916 0 0 0-.977 2.637h9.805c-.156-.99-.488-1.869-.996-2.637-.495-.781-1.094-1.374-1.797-1.777z"
        fill="#94A2B8"
      />
    </svg>
  );
};
